// Campo de motivo / razón de los modales de cancelar, restaurar y reaperturar.
// Compartido por los dos grids (reclamaciones y eventos), que replican los mismos modales.

// Largo mínimo que la validación ya exigía, pero que no se le comunicaba al usuario.
export const REASON_MIN_LENGTH = 6;

// Referencia del contador. NO se aplica como límite todavía (sin maxLength, a propósito).
// Los motivos terminan en SIC.AuditLog.Message, que es nvarchar(500). En la reapertura el audit
// antepone "[REAPERTURA: RECONSIDERACIÓN] Fecha de solicitud cliente: <fecha> - ", que ocupa hasta
// 79 caracteres, así que al motivo solo le quedan 421.
export const REASON_MAX_REFERENCE = 500;
export const REOPEN_REASON_MAX_REFERENCE = 421;

export const reasonHelperText = (value: string, maxReference: number): string =>
  `${value.length}/${maxReference} caracteres (mínimo ${REASON_MIN_LENGTH})`;
